import {ROLE} from 'api/constants';
import {User} from 'api/types/userTypes';
import {UserDTO} from 'api/typesDTO/userDTO';
import {USER_TYPE} from 'containers/ManageUserPage/userType';
import {
  convertOrganizationDTOToOrganization,
  convertOrganizationToOrganizationDTO,
} from './organisationConverters';

export const convertRoleToUserType = (role: string) => {
  switch (role) {
    case ROLE.admin:
      return USER_TYPE.SUPER_ADMIN.id;
    case ROLE.manager:
      return USER_TYPE.ADMIN.id;
    case ROLE.teacher:
      return USER_TYPE.CONTENT_CREATOR.id;
    case ROLE.student:
      return USER_TYPE.LEARNER.id;
    default:
      return '';
  }
};

export const convertUserTypeToRole = (userType: string) => {
  switch (userType) {
    case USER_TYPE.SUPER_ADMIN.id:
      return ROLE.admin;
    case USER_TYPE.ADMIN.id:
      return ROLE.manager;
    case USER_TYPE.CONTENT_CREATOR.id:
      return ROLE.teacher;
    case USER_TYPE.LEARNER.id:
      return ROLE.student;
    default:
      return '';
  }
};

export const convertUserToUserDTO = ({
  id,
  name,
  email,
  role,
  image,
  organization,
}: User): UserDTO => ({
  id,
  name,
  email,
  role: convertUserTypeToRole(role),
  photo: image,
  organization: organization
    ? convertOrganizationToOrganizationDTO(organization)
    : undefined,
});

export const convertUserDTOToUser = ({
  id,
  name,
  email,
  role,
  photo,
  organization,
}: UserDTO): User => ({
  id,
  name,
  email,
  role: convertRoleToUserType(role),
  image: photo,
  organization: organization
    ? convertOrganizationDTOToOrganization(organization)
    : undefined,
});
